import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsemptySelectionsvg = lazy(
  () => import('./svg-components/digital-forms-submission-details-empty-selection-svg')
);

const DigitalFormsSubmissionDetailsEmptySelectionSvg = ({
  assetsFallbackProps = {},
  customFallback,
  ...rest
}: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsemptySelectionsvg {...rest} />
  </Suspense>
);

export default DigitalFormsSubmissionDetailsEmptySelectionSvg;
